;(function ($, window, document, undefined) {

    "use strict";

    var pluginName = "userMap";
    var defaults = {
        debug: false,
        google: true,
        callback: null,
        zoom: 6,
        lat: 54.831544240801676,
        lng: -2.9583862290712775,
        maptype: null,
    };
    var element, users, pagination, markers, infowindow;

    function UserMap(element, options) {
        this.element = $(element);
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        return this.init();
    }

    $.extend(UserMap.prototype, {
        init: function () {
            this.markers = [];
            this.users = [];
            this.load();
            this.createMap();
            return this;
        },
        load: function () {
            this.zoom = this.settings.zoom || this.element.data('zoom');
            this.lat = this.settings.lat || this.element.data('lat');
            this.lng = this.settings.lng || this.element.data('lng');
            this.log(this.lat, 'load');
            this.log(this.lng, 'load');
        },
        drawUsers: function (users) {
            this.clearMarkers();
            $.each(users.data, function (index, user) {
                this.markers[index] = new google.maps.Marker({
                    position: {lat: user.location.lat, lng: user.location.lng},
                    map: this.map,
                    title: user.username,
                    icon: {
                        url: user.avatar.thumb,
                        scaledSize: new google.maps.Size(30, 30)
                    },
                });
                var content = '<h3>' + user.username + '</h3>' + '<a href="' + user.url + '">View profile</a>';
                google.maps.event.addListener(this.markers[index], 'click', (function (marker, content) {
                    return function () {
                        this.infowindow.setContent(content);
                        this.infowindow.open(this.map, marker);
                    }.bind(this);
                }.bind(this))(this.markers[index], content));
            }.bind(this));
        },
        runCallback: function () {
            this.log('runCallback');
            if (this.settings.callback) {
                this.settings.callback(this.map.getBounds());
            }
        },
        clearMarkers: function () {
            $.each(this.markers, function (index, marker) {
                marker.setMap(null);
            });
            this.markers = [];
        },
        createMap: function () {
            this.element.removeClass('loading');

            this.map = new google.maps.Map(this.element.get(0), {
                zoom: parseInt(this.zoom),
                center: new google.maps.LatLng(this.lat, this.lng),
                panControl: false,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: true,
                streetViewControl: false,
                overviewMapControl: false
            });

            this.infowindow = new google.maps.InfoWindow();

            google.maps.event.addListener(this.map, 'bounds_changed', _.debounce(function () {
                this.runCallback();
            }.bind(this), 100));
        },
        setZoomLevel: function (value) {
            if (!this.map) {
                return false;
            }

            this.map.setZoom(parseInt(value));
        },
        log: function (data, key) {
            if (this.settings.debug == false) return;
            key = (!key ? '' : key);
            console.log('UserMap ' + key, data);
        }
    });

    $.fn[pluginName] = function (options) {
        if ((options === undefined) || (typeof options === 'object')) {
            return this.each(function () {
                if (!$.data(this, "plugin_" + pluginName)) {
                    $.data(this, "plugin_" + pluginName, new UserMap(this, options));
                }
            });
        }

        if ((typeof options === 'string') && (options[0] !== '_') && (options !== 'init')) {
            var returns, args = arguments;

            this.each(function () {
                var instance = $.data(this, 'plugin_' + pluginName);

                if ((instance instanceof UserMap) && (typeof instance[options] === 'function')) {
                    returns = instance[options].apply(instance, Array.prototype.slice.call(args, 1));
                }

                if (options === 'destroy') {
                    $.data(this, 'plugin_' + pluginName, null);
                }
            });

            return returns !== undefined ? returns : this;
        }
    };

})(jQuery, window, document);
